function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ae42;}.cls-2{fill:#fff;}.cls-3{fill:#231f20;}.cls-4{fill:#ffd100;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0V17H130V0ZM88.51,16.62H.38V.38H88.5l6.14,8.43Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "88.5 0.38 0.38 0.38 0.38 16.62 88.51 16.62 94.64 8.81 88.5 0.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M98.94,10.78a.46.46,0,0,1,.43-.48c.38,0,.66.56,1.31.56a.94.94,0,0,0,1-1c0-1.26-2.51-1.29-2.51-3.18A1.63,1.63,0,0,1,101,5c.81,0,1.47.38,1.47.85a.46.46,0,0,1-.43.48c-.29,0-.53-.32-1-.32a.72.72,0,0,0-.78.74c0,1.18,2.51,1.16,2.51,3.11a1.91,1.91,0,0,1-2.06,2C99.76,11.87,98.94,11.36,98.94,10.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M103.8,11.3a.58.58,0,1,1,1.15,0,.58.58,0,0,1-1.15,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M106.35,11.17V5.7a.53.53,0,0,1,.57-.6h2.38c.35,0,.56.18.56.48s-.21.49-.56.49h-1.65c-.17,0-.26.07-.26.2V7.7c0,.14.1.21.26.21H109a.42.42,0,0,1,.48.44.43.43,0,0,1-.48.46h-1.38c-.17,0-.26.07-.26.21v1.57c0,.15.09.21.26.21h1.65c.35,0,.56.18.56.49s-.21.48-.56.48h-2.38A.53.53,0,0,1,106.35,11.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M111.22,11.3a.58.58,0,1,1,1.15,0,.58.58,0,0,1-1.15,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M113.73,11.15V5.6a.53.53,0,1,1,1,0v4.93a.2.2,0,0,0,.23.23h1.43c.36,0,.57.19.57.51s-.21.5-.57.5h-2.12A.56.56,0,0,1,113.73,11.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M118.17,11.3a.58.58,0,1,1,.59.57A.55.55,0,0,1,118.17,11.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M120.49,11.27V5.7a.53.53,0,0,1,.57-.6h2.39c.34,0,.55.18.55.48s-.21.49-.55.49h-1.71a.19.19,0,0,0-.2.2V7.73a.19.19,0,0,0,.2.2h1.4c.33,0,.52.17.52.47a.46.46,0,0,1-.52.47h-1.4a.19.19,0,0,0-.2.21v2.19a.53.53,0,1,1-1.05,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M123.59,11.3a.58.58,0,1,1,1.15,0,.58.58,0,0,1-1.15,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4.94,11.05a.55.55,0,0,1,.67-.88,2.84,2.84,0,0,0,1.86.68c.72,0,1.17-.34,1.17-.83v0c0-.48-.26-.73-1.5-1-1.41-.34-2.21-.75-2.21-2V7A2,2,0,0,1,7.2,5.06a3.62,3.62,0,0,1,2.1.62.5.5,0,0,1,.26.46A.55.55,0,0,1,9,6.68a.61.61,0,0,1-.3-.08,2.72,2.72,0,0,0-1.53-.51c-.68,0-1.08.35-1.08.79v0c0,.51.3.74,1.58,1s2.13.85,2.13,2h0c0,1.25-1,2-2.37,2A4.16,4.16,0,0,1,4.94,11.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M12.34,6.24H10.73a.55.55,0,0,1,0-1.09h4.4a.55.55,0,0,1,0,1.09H13.51v5a.59.59,0,0,1-1.17,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M15,11l2.47-5.5a.74.74,0,0,1,.7-.47h0a.74.74,0,0,1,.7.47L21.38,11a.5.5,0,0,1,.07.25.55.55,0,0,1-.55.56.59.59,0,0,1-.57-.41l-.54-1.24H16.56L16,11.47a.57.57,0,0,1-.54.37.54.54,0,0,1-.55-.54A.59.59,0,0,1,15,11Zm4.34-1.87L18.18,6.47,17,9.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M22.46,5.74a.58.58,0,0,1,.59-.59h2.37a2.66,2.66,0,0,1,1.91.67,2,2,0,0,1,.55,1.43v0a2,2,0,0,1-1.51,2l1.27,1.6a.65.65,0,0,1,.19.45.55.55,0,0,1-.56.54.69.69,0,0,1-.57-.31l-1.61-2H23.62v1.78a.58.58,0,1,1-1.16,0Zm2.87,2.7c.83,0,1.37-.43,1.37-1.1v0c0-.71-.52-1.1-1.38-1.1h-1.7V8.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M30.47,6.24H28.86a.55.55,0,0,1,0-1.09h4.4a.55.55,0,0,1,0,1.09H31.64v5a.59.59,0,0,1-1.17,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M49,11.05a.51.51,0,0,1-.23-.44.54.54,0,0,1,.55-.54.53.53,0,0,1,.34.1,2.86,2.86,0,0,0,1.86.68c.72,0,1.17-.34,1.17-.83v0c0-.48-.26-.73-1.49-1C49.81,8.64,49,8.23,49,7V7a2,2,0,0,1,2.26-1.92,3.65,3.65,0,0,1,2.11.62.51.51,0,0,1,.25.46.54.54,0,0,1-.55.54.61.61,0,0,1-.3-.08,2.69,2.69,0,0,0-1.53-.51c-.68,0-1.08.35-1.08.79v0c0,.51.31.74,1.59,1s2.12.85,2.12,2h0c0,1.25-1,2-2.37,2A4.13,4.13,0,0,1,49,11.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M55.17,11.2V5.74a.58.58,0,0,1,.59-.59h3.86a.53.53,0,0,1,.52.53.52.52,0,0,1-.52.52H56.34V7.92h2.85a.53.53,0,0,1,.53.53.52.52,0,0,1-.53.52H56.34v1.78h3.33a.52.52,0,0,1,0,1H55.76A.58.58,0,0,1,55.17,11.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M61.21,11.05a.55.55,0,0,1,.67-.88,2.84,2.84,0,0,0,1.86.68c.72,0,1.17-.34,1.17-.83v0c0-.48-.26-.73-1.5-1C62,8.64,61.2,8.23,61.2,7V7a2,2,0,0,1,2.27-1.92,3.62,3.62,0,0,1,2.1.62.5.5,0,0,1,.26.46.55.55,0,0,1-.55.54A.61.61,0,0,1,65,6.6a2.72,2.72,0,0,0-1.53-.51c-.68,0-1.08.35-1.08.79v0c0,.51.3.74,1.58,1s2.13.85,2.13,2h0c0,1.25-1,2-2.37,2A4.16,4.16,0,0,1,61.21,11.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M66.84,11l2.46-5.5a.74.74,0,0,1,.7-.47h.06a.73.73,0,0,1,.69.47L73.22,11a.61.61,0,0,1,.06.25.54.54,0,0,1-.55.56.61.61,0,0,1-.57-.41l-.54-1.24H68.4l-.56,1.28a.55.55,0,0,1-.54.37.54.54,0,0,1-.54-.54A.59.59,0,0,1,66.84,11Zm4.34-1.87L70,6.47,68.85,9.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M74.29,5.7a.58.58,0,0,1,.59-.58H75a.63.63,0,0,1,.54.31l2,3.15,2-3.16a.6.6,0,0,1,.54-.3h.12a.58.58,0,0,1,.59.58v5.56a.58.58,0,0,1-.59.58.59.59,0,0,1-.58-.58v-4L78,9.71a.58.58,0,0,1-.49.31.59.59,0,0,1-.49-.31L75.44,7.3v4a.58.58,0,0,1-1.15,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M82.46,11.2V5.74a.58.58,0,0,1,.59-.59h3.86a.53.53,0,0,1,.52.53.52.52,0,0,1-.52.52H83.63V7.92h2.85a.52.52,0,0,1,.52.53.52.52,0,0,1-.52.52H83.63v1.78H87a.52.52,0,1,1,0,1h-3.9A.58.58,0,0,1,82.46,11.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M35,7.45a.31.31,0,0,1,0-.13.33.33,0,0,1,.65-.08l.59,1.82.59-1.8A.34.34,0,0,1,37.09,7h0a.33.33,0,0,1,.33.26l.6,1.8.59-1.82A.32.32,0,0,1,39,7a.31.31,0,0,1,.29.44l-.83,2.33a.35.35,0,0,1-.33.26H38a.36.36,0,0,1-.34-.26l-.58-1.7-.58,1.7a.36.36,0,0,1-.34.26h-.07a.35.35,0,0,1-.33-.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M40.07,7.33a.33.33,0,0,1,.66,0V9.69a.33.33,0,1,1-.66,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M42.14,7.63h-.63a.3.3,0,0,1-.3-.3.31.31,0,0,1,.3-.3h1.91a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3h-.63V9.69a.33.33,0,1,1-.65,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M44.19,7.33a.33.33,0,0,1,.66,0V8.2h1.2V7.33a.33.33,0,0,1,.65,0V9.69a.33.33,0,1,1-.65,0V8.81h-1.2v.88a.33.33,0,1,1-.66,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M46.49,6H35.26a.44.44,0,1,1,0-.87H46.49a.44.44,0,1,1,0,.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M46.49,11.79H35.26a.44.44,0,0,1,0-.88H46.49a.44.44,0,1,1,0,.88Z"
})));

function SvgStartWithSesameHAbrv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWithSesameHAbrv);
export default __webpack_public_path__ + "static/media/StartWithSesame_H_Abrv.eb2a934c.svg";
export { ForwardRef as ReactComponent };